<article
  class="my-1 w-full break-inside-avoid rounded-lg bg-white p-4 text-left shadow-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:shadow-xl"
>
  @if (isMyNumerons()) {
    <a [routerLink]="collectionHref(collection()._id)" [queryParams]="manageQueryParams()">
      @if (displayImage(collection()); as imagePath) {
        <img [src]="imagePath" alt="" class="block w-full rounded-none" loading="lazy" />
      }
    </a>
  } @else {
    <a [href]="collectionHref(collection()._id)">
      @if (displayImage(collection()); as imagePath) {
        <img [src]="imagePath" alt="" class="block w-full rounded-none" loading="lazy" />
      }
    </a>
  }

  <div class="my-4">
    <div class="text-sm text-text">
      @if (isMyNumerons()) {
        <a
          [routerLink]="collectionHref(collection()._id)"
          [queryParams]="manageQueryParams()"
          class="text-primary no-underline"
        >
          {{ collection().title }}
          <span
            class="ml-1 inline-flex rounded-lg bg-primary px-2 py-1 text-xs font-semibold text-primary-contrast"
          >
            {{ collection().numerons.length }}
          </span>
        </a>
      } @else {
        <a [href]="collectionHref(collection()._id)" class="text-primary no-underline">
          {{ collection().title }}
          <span
            class="ml-1 inline-flex rounded-lg bg-primary px-2 py-1 text-xs font-semibold text-primary-contrast"
          >
            {{ collection().numerons.length }}
          </span>
        </a>
      }
    </div>
    <div class="mt-2 text-xs text-secondary">
      Last Modified:
      {{ collection().lastModified | date: 'dd-MMM-yyyy h:mm a' }}
    </div>
  </div>

  <div class="mb-4 grid grid-cols-3">
    <div class="flex items-center gap-1 text-sm text-text-muted">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        class="h-4 w-4"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178Z"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        />
      </svg>
      @if ((collection().views ?? 0) > 0) {
        <small class="ml-0 mr-0">{{ collection().views }}</small>
      }
    </div>
    <div class="flex items-center gap-1 text-sm text-text-muted">
      <button
        type="button"
        class="inline-flex rounded p-0.5 transition-colors duration-200 ease-in-out hover:bg-surface-muted"
        (click)="likeCollection()"
        aria-label="Like collection"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          class="h-4 w-4"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m21.435 6.582-1.89-1.89a5.25 5.25 0 0 0-7.424 0L12 4.813l-.121-.121a5.25 5.25 0 0 0-7.425 7.424l1.89 1.89L12 19.667l5.656-5.66 1.89-1.89a5.25 5.25 0 0 0-.111-7.535Z"
          />
        </svg>
      </button>
      @if (collectionLikes() > 0) {
        <small class="ml-0 mr-0">{{ collectionLikes() }}</small>
      }
    </div>
    <div class="flex items-center gap-1 text-sm text-text-muted">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        class="h-4 w-4"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M2.25 12.76c0 1.6.85 3.04 2.22 4.07.15.11.26.28.3.47l.6 2.4a.375.375 0 0 0 .56.24l2.24-1.27a.75.75 0 0 1 .53-.07c1.05.27 2.16.41 3.3.41 5.25 0 9.5-3.13 9.5-7s-4.25-7-9.5-7-9.5 3.13-9.5 7Z"
        />
      </svg>
      @if ((collection().numComments ?? 0) > 0) {
        <small class="ml-0 mr-0">{{ collection().numComments }}</small>
      }
    </div>
  </div>

  <hr class="my-0 border-t border-subtle" />

  <div class="my-2 text-sm text-text-muted">
    <div>
      Posted by
      @if (isMyNumerons()) {
        {{ collection().user?.displayName }}
      } @else {
        <a [href]="byPublisherHref(collection().user?._id)" class="text-secondary no-underline">
          {{ collection().user?.displayName }}
        </a>
      }
      in
      @if (isMyNumeronsByTopic()) {
        {{ collection().topic?.topic }}
      } @else {
        <a [href]="byTopicHref(collection().topic?._id)" class="text-secondary no-underline">
          {{ collection().topic?.topic }}
        </a>
      }
    </div>
    <div>
      Tags
      @for (category of collection().categories ?? []; track category) {
        <a [href]="byCategoryHref(category)" class="mr-1 inline-block text-secondary no-underline">
          {{ category }}
        </a>
      }
    </div>
    <div class="mt-2">
      Source
      @if (hasExternalSource(collection().url)) {
        <a
          [href]="collection().url"
          target="_blank"
          rel="noopener noreferrer"
          class="text-secondary no-underline"
        >
          {{ collection().source }}
        </a>
      } @else {
        {{ collection().source }}
      }
    </div>
  </div>

  @if (isMyNumerons()) {
    <hr class="my-0 border-t border-subtle" />

    <div class="mt-3 grid grid-cols-3">
      <a
        class="inline-flex items-center justify-center text-text-muted"
        [routerLink]="editHref(collection()._id)"
        [queryParams]="editQueryParams()"
        aria-label="Edit collection"
        title="Edit"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          class="h-4 w-4"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m16.862 4.487 1.687-1.688a2.25 2.25 0 1 1 3.182 3.182L10.582 17.13a4.5 4.5 0 0 1-1.897 1.13L6 19l.74-2.685a4.5 4.5 0 0 1 1.13-1.897L16.862 4.487Z"
          />
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 7.125 16.875 4.5" />
        </svg>
      </a>
      <button
        type="button"
        class="inline-flex items-center justify-center text-text-muted"
        [disabled]="isCopying()"
        (click)="copyCollection()"
        aria-label="Copy collection"
        title="Copy"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          class="h-4 w-4"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125H6.375a1.125 1.125 0 0 1-1.125-1.125V8.25c0-.621.504-1.125 1.125-1.125H9.75"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 3.75h4.125c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125H10.875A1.125 1.125 0 0 1 9.75 16.125V4.875c0-.621.504-1.125 1.125-1.125H15Z"
          />
        </svg>
      </button>
      <a
        class="inline-flex items-center justify-center text-text-muted"
        [routerLink]="deleteHref(collection()._id)"
        [queryParams]="deleteQueryParams(collection())"
        aria-label="Delete collection"
        title="Delete"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          class="h-4 w-4"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673A2.25 2.25 0 0 1 15.916 21.75H8.084A2.25 2.25 0 0 1 5.84 19.673L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0C9.165 2.313 8.255 3.296 8.255 4.477v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
          />
        </svg>
      </a>
    </div>

    @if (copyErrorMessage()) {
      <p class="mt-2 text-sm text-danger">{{ copyErrorMessage() }}</p>
    }
  }
</article>
